<template>
    <button
        :disabled="$attrs.disabled || loading"
        :type="type"
        class="h-12 w-full disabled:bg-gray-500 cursor-pointer flex items-center justify-center rounded-full text-base font-black"
        :class="[
            active ? 'bg-indigo-700' : '',
            $attrs.disabled ? '' : hoverColors[color],
            styles[color] || color
        ]"
    >
        <span>
            <Loader v-if="loading" class="h-6 w-6 text-white"/>
            <slot v-else/>
        </span>
    </button>
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
    components: {
        Loader: defineAsyncComponent(() => import("@/Components/Svg/Loader.vue"))
    },
    props: {
        type: {
            type: String,
            default: 'submit',
        },
        active: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'black'
        },
        textColor: {
            type: String,
            default: 'white'
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        return {
            hoverColors: {
                black: 'hover:bg-[#292929]',
                indigo: 'hover:bg-indigo-600',
                green: 'hover:bg-green-600',
                white: 'hover:bg-amber-100',
            },
            styles: {
                white: 'bg-white border-2 border-indigo-500',
                black: 'bg-black text-white',
                indigo: 'bg-indigo-500 text-white',
                green: 'bg-green-500',
            }
        }
    }
}
</script>
